import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import DatePicker from 'react-datepicker2';
import SelectAsync from "react-select/async";

export default class Person extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            refreshAfterSave: this.isNull(props.RefreshAfterSave) ? true : props.RefreshAfterSave,
            fromAutoComplete: this.isNull(props.FromAutoComplete) ? false : props.FromAutoComplete,
            onSetPerson: this.isNull(props.OnSetPerson) ? null : props.OnSetPerson,
            callbackData: this.isNull(props.CallbackData) ? null : props.CallbackData,
            caller: props.Caller,
            data: null,
            caller: this.isBlank(props.Caller) ? "persons" : props.Caller,
            loading: true,
            organPosts: [],
            organWorkingGroup: [],
            pic: '',
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/person/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                    this.state.organPosts = data.organPosts;
                    this.state.organWorkingGroup = data.organWorkingGroup;
                    this.setState({
                        loading: false
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setProfilePic(_file) {
        this.getBase64(_file).then(file => {
            this.state.pic = file;
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;

        var bfv = [];
        this.state.data.baseFieldValues.forEach(f => {
            var clone = Object.assign({}, f);
            if (clone.dataType === 3) clone.value = this.convertMomentToDb(clone.value);
            bfv.push(clone);
        });

        this.httpPost("api/v1/person/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            parentId: this.isNull(this.state.data.record.parentId) ? this.getDefaultGuid() : this.state.data.record.parentId,
            address: this.state.data.record.address,
            pasportNo: this.state.data.record.pasportNo,
            economicCode: this.state.data.record.economicCode,
            nationalId: this.state.data.record.nationalId,
            email: this.state.data.record.email,
            mobile: this.state.data.record.mobile,
            name: this.state.data.record.name,
            phone: this.state.data.record.phone,
            type: this.state.data.record.type,
            zipCode: this.state.data.record.zipCode,
            branchCode: this.state.data.record.branchCode,
            isSupplier: this.state.data.record.isSupplier,
            isCustomer: this.state.data.record.isCustomer,
            isEmployer: this.state.data.record.isEmployer,
            fatherName: this.state.data.record.fatherName,
            shenasname: this.state.data.record.shenasname,
            sodor: this.state.data.record.sodor,
            birthLocation: this.state.data.record.birthLocation,
            registerDate: this.state.data.record.registerDate,
            birthDate: this.state.data.record.birthDate,
            childrenCount: parseInt(this.state.data.record.childrenCount),
            gender: parseInt(this.state.data.record.gender),
            marriage: parseInt(this.state.data.record.marriage),
            educationGrade: parseInt(this.state.data.record.educationGrade),
            code: parseInt(this.state.data.record.code),
            city: this.state.data.record.city,
            province: this.state.data.record.province,
            country: this.state.data.record.country,
            activityType: this.state.data.record.activityType,
            magta: this.state.data.record.magta,
            field: this.state.data.record.field,
            sabege: this.state.data.record.sabege,
            job: this.state.data.record.job,
            base64Pic: this.state.pic,

            crmSourceId: this.state.data.record.crmSourceId,
            
            categories: this.state.data.categories,
            baseFieldValues: bfv,

            organPosts: this.state.organPosts,
            organWorkingGroup: this.state.organWorkingGroup
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    if (this.state.fromAutoComplete) {
                        if (this.isNull(this.state.onSetPerson)) {
                            this.state.caller.setPerson({
                                fullCode: data.record.code,
                                accountId: data.record.accountId,
                                value: data.record.id,
                                label: data.record.code + "-" + this.state.data.record.name
                            });
                        }
                        else {
                            this.state.onSetPerson({
                                fullCode: data.record.code,
                                accountId: data.record.accountId,
                                value: data.record.id,
                                label: data.record.code + "-" + this.state.data.record.name
                            }, this.state.caller, this.state.callbackData);
                        }
                    }
                    else {
                        if (this.state.refreshAfterSave) {
                            this.state.caller.refreshData();
                        }
                    }

                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setField(baseFieldId, v) {
        this.state.data.baseFieldValues.forEach(f => {
            if (f.baseFieldId === baseFieldId) f.value = v;
        });
    }
    setPersonType(v, e) {
        this.state.data.record.type = v;
        this.setState({ data: this.state.data });
    }
    changeEmployer(e) {
        this.state.data.record.isEmployer = e;
        this.setState({ data: this.state.data });
    }
    changeSupplier(e) {
        this.state.data.record.isSupplier = e;
        this.setState({ data: this.state.data });
    }
    changeCustomer(e) {
        this.state.data.record.isCustomer = e;
        this.setState({ data: this.state.data });
    }
    fieldInCategory(field) {
        var find = false;
        this.state.data.categories.forEach(f => {
            if (field.crmCaseCategoriesId.includes(f)) find = true;
        });
        return find;
    }
    setGroupChecked(groupId, e) {
        var t = [];
        this.state.data.categories.forEach(f => {
            if (f != groupId) t.push(f);
        });
        if (e == true) t.push(groupId);
        this.state.data.categories = t;
    }
    getGroupChecked(groupId) {
        var t = false;
        this.state.data.categories.forEach(f => {
            if (f === groupId) t = true;
        });
        return t;
    }
    setOrganPosts(e) {
        this.state.organPosts = e;
    }
    setOrganWorkingGroups(e) {
        this.state.organWorkingGroup = e;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{"width":"96%"} }>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات شخص" : "افزودن شخص جدید"}
                            </h4>
                        </div>
                        {this.renderBody()}
                    </div>
                </div>
            </div>
        </div>
    }
    renderBody() {
        return [
            <div className="modal-body">
                <div className="container-fluid">
                    <ul className="nav nav-tabs mt-n3">
                        <li className="nav-item">
                            <a className="nav-link active" data-bs-toggle="tab" href="#info"><em className="icon ni ni-info"></em><span>اطلاعات شخص</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="tab" href="#contact"><em className="icon ni ni-info"></em><span>اطلاعات تماس</span></a>
                        </li>
                        {this.state.data.record.type == 1 && <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="tab" href="#personal"><em className="icon ni ni-info"></em><span>اطلاعات پرسنلی</span></a>
                        </li>}
                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="tab" href="#fields"><em className="icon ni ni-info"></em><span>اطلاعات سفارشی</span></a>
                        </li>
                    </ul>

                    <div className="tab-content">
                        <div className="tab-pane active" id="info">
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="form-group">
                                        <label className="form-label">{this.state.data.record.type === 1 ? "نام و نام خانوادگی" : "عنوان"}</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-1">
                                    <div className="form-group">
                                        <label className="form-label">کد</label>
                                        <div className="form-control-wrap">
                                            <input autocomplete="off" defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} onkeypress="return isCharacterKey(event)" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">نوع شخص</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" type="text" defaultValue={this.state.data.record.type} onChange={e => this.setPersonType(parseInt(e.target.value))}>
                                                <option value="1">حقیقی</option>
                                                <option value="2">حقوقی</option>
                                                <option value="3">مشارکت مدنی</option>
                                                <option value="4">اتباع غیر ایرانی</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">نوع فعالیت</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" type="text" defaultValue={this.state.data.record.activityType} onChange={e => this.state.data.record.activityType = parseInt(e.target.value)}>
                                                <option value="0">رسمی</option>
                                                <option value="1">غیررسمی</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>    
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">{this.state.data.record.type === 1 ? "کدملی" : "شناسه ملی"}</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.nationalId} onChange={e => this.state.data.record.nationalId = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">کداقتصادی</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.economicCode} onChange={e => this.state.data.record.economicCode = e.target.value} />
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">کد شعبه</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.branchCode} onChange={e => this.state.data.record.branchCode = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">شماره گذرنامه</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.pasportNo} onChange={e => this.state.data.record.pasportNo = e.target.value} />
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">شماره شناسنامه</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="10" className="form-control" type="text" defaultValue={this.state.data.record.shenasname} onChange={e => this.state.data.record.shenasname = e.target.value} />
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">نام پدر</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="150" className="form-control" type="text" defaultValue={this.state.data.record.fatherName} onChange={e => this.state.data.record.fatherName = e.target.value} />
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">وضعیت تاهل</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" type="text" defaultValue={this.state.data.record.marriage} onChange={e => this.state.data.record.marriage = e.target.value}>
                                                <option value="1">متاهل</option>
                                                <option value="2">مجرد</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">تاریخ تولد</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="10" className="form-control" type="text" defaultValue={this.state.data.record.birthDate} onChange={e => this.state.data.record.birthDate = e.target.value} />
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">جنسیت</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" type="text" defaultValue={this.state.data.record.gender} onChange={e => this.state.data.record.gender = e.target.value}>
                                                <option value="1">خانم</option>
                                                <option value="2">آقا</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">سرنخ</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" type="text" defaultValue={this.state.data.record.crmSourceId} onChange={e => this.state.data.record.crmSourceId = e.target.value}>
                                                <option value={this.getDefaultGuid()}>فاقد سرنخ</option>
                                                {this.state.data.crmSources.map(cat => <option value={cat.id}>{cat.title}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {this.state.data.record.type == 1 &&
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">میزان تحصیلات</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control" type="text" defaultValue={this.state.data.record.educationGrade} onChange={e => this.state.data.record.educationGrade = e.target.value}>
                                                    <option value="1">سیکل</option>
                                                    <option value="2">دیپلم</option>
                                                    <option value="3">کارشناسی</option>
                                                    <option value="4">کارشناسی ارشد</option>
                                                    <option value="5">دکتری</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">مقطع</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="50" className="form-control" type="text" defaultValue={this.state.data.record.magta} onChange={e => this.state.data.record.magta = e.target.value} />
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">رشته</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="50" className="form-control" type="text" defaultValue={this.state.data.record.field} onChange={e => this.state.data.record.field = e.target.value} />
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type !== 2 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">شغل</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="50" className="form-control" type="text" defaultValue={this.state.data.record.job} onChange={e => this.state.data.record.job = e.target.value} />
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type !== 2 && <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">سابقه</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="400" className="form-control" type="text" defaultValue={this.state.data.record.sabege} onChange={e => this.state.data.record.sabege = e.target.value} />
                                        </div>
                                    </div>
                                </div>}
                            </div>

                            {this.state.data.record.type !== 2 && <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">انتخاب پستهای سازمانی</label>
                                        <div className="form-control-wrap">
                                            <SelectAsync
                                                defaultValue={this.state.organPosts}
                                                isMulti={true}
                                                placeholder="پستهای سازمانی"
                                                defaultOptions
                                                loadOptions={this.loadOrganPositionOptions}
                                                onChange={e => this.setOrganPosts(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            {this.state.data.record.type !== 2 && <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">انتخاب کارگروه های سازمانی</label>
                                        <div className="form-control-wrap">
                                            <SelectAsync
                                                defaultValue={this.state.organWorkingGroup}
                                                isMulti={true}
                                                placeholder="کارگروه های سازمانی"
                                                defaultOptions
                                                loadOptions={this.loadOrganWorkingGroupOptions}
                                                onChange={e => this.setOrganWorkingGroups(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">گروه ها</label>
                                        <div className="form-control-wrap">
                                            {this.state.data.groups.map(group => <span className="me-4" style={{ "display": "inline-block" }}><input defaultChecked={this.getGroupChecked(group.id)} onChange={e => this.setGroupChecked(group.id, e.target.checked)} type="checkbox" /> {group.name}</span>)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="contact">
                            <div className="row">
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">شماره موبایل</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.mobile} onChange={e => this.state.data.record.mobile = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">شماره تلفن</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.phone} onChange={e => this.state.data.record.phone = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label className="form-label">آدرس ایمیل</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.email} onChange={e => this.state.data.record.email = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">کدپستی</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.zipCode} onChange={e => this.state.data.record.zipCode = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">کشور</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.country} onChange={e => this.state.data.record.country = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">استان/ایالت</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.province} onChange={e => this.state.data.record.province = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">شهر</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.city} onChange={e => this.state.data.record.city = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">آدرس</label>
                                        <div className="form-control-wrap">
                                            <textarea className="form-control" type="text" defaultValue={this.state.data.record.address} onChange={e => this.state.data.record.address = e.target.value} ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.data.record.type == 1 && <div className="tab-pane" id="personal">
                            <div className="row">
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">کدپرسنلی</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="20" className="form-control" type="text" defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">محل تولد</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="150" className="form-control" type="text" defaultValue={this.state.data.record.birthLocation} onChange={e => this.state.data.record.birthLocation = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">محل صدور</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="150" className="form-control" type="text" defaultValue={this.state.data.record.sodor} onChange={e => this.state.data.record.sodor = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">تاریخ استخدام</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="10" className="form-control" type="text" defaultValue={this.state.data.record.registerDate} onChange={e => this.state.data.record.registerDate = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">تعداد فرزند</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="10" className="form-control" type="text" defaultValue={this.state.data.record.childrenCount} onChange={e => this.state.data.record.childrenCount = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">تصویر</label>
                                        <div className="form-control-wrap">
                                            <input type="file" onChange={(e) => { this.setProfilePic(e.target.files[0]) }} />
                                        </div>
                                    </div>
                                </div>
                                {!this.isBlank(this.state.data.record.pic) && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">تصویر فعلی</label>
                                        <div className="form-control-wrap">
                                            <a href={this.state.data.record.picPath} target="_blank"><img src={this.state.data.record.picPath} style={{ width: "100px", "height": "100px" }} /></a>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>}
                        <div className="tab-pane" id="fields">
                            <div className="row">
                                {this.state.data.baseFieldValues.map(field => this.fieldInCategory(field) && [
                                    field.dataType === 1 && <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">{field.label}:</label>
                                            <input defaultValue={field.value} onChange={e => this.setField(field.baseFieldId, e.target.value)} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    ,
                                    field.dataType === 2 && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">{field.label}:</label>
                                            <input defaultValue={field.value} onChange={e => this.setField(field.baseFieldId, e.target.value)} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    ,
                                    field.dataType === 3 && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">{field.label}:</label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.setField(field.baseFieldId, e) }}
                                                value={this.getFormatedDateForDatePicker(field.value)}
                                            />
                                        </div>
                                    </div>
                                ])}
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <div className="modal-footer">
                <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}><span className="shortcut">Esc - </span>انصراف</button>
                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                    <span className="shortcut">F4 - </span> ذخیره
                </button>
            </div>
        ];
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline ? this.renderBody() : this.renderForm()
            ];

        return contents;
    }
}